import { retrieveMatterSettingStaticsQueryOptions } from "@/lib/data/react-query/matters/matter-setting-statics";
import type { MatterSettingStaticOption } from "@/lib/data/requests/matters/matter-setting-statics";
import { useQuery } from "@tanstack/react-query";

const EMPTY_ACTION_OPTIONS: MatterSettingStaticOption[] = [];

export function useMatterTaskPlanActions() {
  const { data, isLoading, isError } = useQuery(
    retrieveMatterSettingStaticsQueryOptions(),
  );

  return {
    actionOptions: data?.data.taskPlanActions ?? EMPTY_ACTION_OPTIONS,
    isLoading,
    isError,
  };
}
